import CityPageTemplate from './CityPageTemplate';

export default function MaitlandPage() {
  return (
    <CityPageTemplate
      city="Maitland"
      county="Orange"
      slug="maitland"
      zipCodes={['32751']}
      neighborhoods={['Downtown Maitland', 'Lake Lily', 'Dommerich', 'Maitland Center', 'Kewannee']}
      localContext="Serving Maitland's historic Lake Lily district and the Maitland Center business corridor, where homes and offices demand a meticulous clean."
      metaDescription="Professional residential and commercial cleaning services in Maitland, FL. Serving ZIP code 32751. We Bring the Boom to Every Room. Call SOTSVC today!"
    />
  );
}
